// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// import commerical1 from "../../assets/chd-open-1.png";
// import commerical2 from "../../assets/chd-open-2.png";
// import commerical3 from "../../assets/chd-open-3.png";
// import commerical4 from "../../assets/chd-open-4.png";
// import commerical5 from "../../assets/chd-open-5.png";
// import commerical6 from "../../assets/chd-open-6.png";
// import commerical7 from "../../assets/chd-open-7.png";
// import commerical8 from "../../assets/chd-open-8.png";

// export default function CommercialHorticultureOpen() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Commercial Horticulture Development in open field conditions on project mode from NHB</h1>
                                  
//                                   <p>(a) Activity (ies) allowed and Area norms: National Horticulture Board will take up integrated commercial horticulture development projects in open field conditions on project mode , including components viz planting material, plantation, irrigation, fertigation, mechanization, precision farming, GAP etc. for projects covering area over 2.00 ha. (5 Acres).In case of NE Region, projects having area over 1 Acre are eligible (F. No. 12-40/2016-MIDH (NHB) dated July, 2017). Integration of production unit with on farm PHM components and primary processing unit shall also be allowed in project mode. Cost of raising new plantation will vary from crop to crop, which will be taken into consideration while providing assistance to the beneficiary. Integrated production unit on Mushroom and tissue culture shall also be eligible for assistance under this component.</p>
                                  

//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                 <p>The components like farm machinery and PHM infrastructure, irrigation and micro irrigation etc shall be eligible under the scheme for assistance in existing/new orchards/projects to increase productivity.</p>
//                                 <p>(b) Crop eligible: May please see from cost norms of Open field cultivation under NHB scheme.</p>
//                                 <p>(c) Pattern of assistance: Credit linked back-ended subsidy @ 40% of the total project cost limited to Rs 30.00 lakh per project in general areas and @ 50% of project cost limited to Rs. 37.50 lakh in NE Region, Hilly States and scheduled areas.</p>

//                                   <h2 className="align-items-center">1.1.(d).Maximum Project costs allowed for subsidy calculation</h2>
                                  
//                                   <img src={commerical1} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                              
//                               <h2 className="align-items-center">1.1.(e).Cost norms for Open field cultivation under NHB Scheme:</h2>
//                               <img src={commerical2} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={commerical3} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={commerical4} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={commerical5} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={commerical6} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />

//                                   <h2>Note:</h2>
//                                   <p>1. Wherever cost norms are not given, cost norms available under MIDH scheme for similar activity shall be followed. In case norms are not available under MIDH schemes also, cost appraised by bank as per bank norms or approved by Competent Committee of NHB shall apply.</p>
//                                   <p>2. In project mode, applicant may opt for add on components as per norms given in table 1.1. (f) but unless otherwise specified, cost ceiling, as prescribed for each crop/activity shall be applied where cost of add on components exceeds prescribed ceiling .</p>
                              
                                                           
//                                   <h2 className="align-items-center">1.1.(f).Norms for Technology Add on components and other essential components of Integrated Commercial Horticulture projects</h2>
//                                   <img src={commerical7} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={commerical8} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                              
//                               <p>Components categorization:</p>
//                               <p>* Commercial Horticulture, within overall cost ceiling</p>
//                               <p># Protected Cultivation, within overall cost ceiling</p>
//                               <p>## Over and above overall cost ceiling</p>
//                               <p>Any other add on component as may be decided by Project Approval Committee for inclusion of new item(s) may be suitably incorporated from time to time.</p>
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function CommercialHorticultureOpen() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Commercial Horticulture Development (Open Field) – NHB Scheme
              </h1>

              <p>
                The NHB scheme promotes large-scale horticulture projects using
                modern farming techniques to improve productivity, profitability,
                and sustainability.
              </p>

              <p>
                It supports farmers and entrepreneurs in establishing orchards,
                plantations, and integrated agri projects.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Promote commercial cultivation</li>
            <li><FaCheckCircle /> Increase productivity</li>
            <li><FaCheckCircle /> Adopt modern technologies</li>
            <li><FaCheckCircle /> Improve farmer income</li>
            <li><FaCheckCircle /> Support integrated farming</li>
          </ul>

          {/* ACTIVITIES */}
          <h2 className="section-title">
            <FaList className="icon" /> Activities Covered
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Orchard & plantation development</li>
            <li><FaCheckCircle /> Irrigation & fertigation systems</li>
            <li><FaCheckCircle /> Precision farming techniques</li>
            <li><FaCheckCircle /> Farm mechanization</li>
            <li><FaCheckCircle /> Post-harvest infrastructure</li>
          </ul>

          {/* SUBSIDY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Pattern of Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 40% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & special areas)</li>
            <li><FaCheckCircle /> Credit-linked subsidy</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility & Project Size
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Minimum 2 hectares (general areas)</li>
            <li><FaCheckCircle /> Minimum 1 hectare (NE/hilly areas)</li>
            <li><FaCheckCircle /> Farmers, FPOs & companies</li>
            <li><FaCheckCircle /> Cooperatives & institutions</li>
          </ul>

          {/* CROPS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Crop Coverage
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Fruits (Mango, Banana, Apple, etc.)</li>
            <li><FaCheckCircle /> Plantation crops</li>
            <li><FaCheckCircle /> Exotic crops</li>
            <li><FaCheckCircle /> Medicinal & aromatic crops</li>
          </ul>

          {/* COST */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Cost Norms
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Based on crop & plantation density</li>
            <li><FaCheckCircle /> Includes irrigation & infrastructure</li>
            <li><FaCheckCircle /> Standardized per acre norms</li>
          </ul>

          {/* TECH */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Technology Add-ons
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Drip irrigation & fertigation</li>
            <li><FaCheckCircle /> Precision farming tools</li>
            <li><FaCheckCircle /> Water harvesting systems</li>
            <li><FaCheckCircle /> Sustainable farming methods</li>
          </ul>

          {/* INFRA */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Farm Infrastructure
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Farm machinery & equipment</li>
            <li><FaCheckCircle /> Storage & pack houses</li>
            <li><FaCheckCircle /> Grading & sorting units</li>
            <li><FaCheckCircle /> Organic input systems</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including DPR preparation,
            crop selection, subsidy planning, bank coordination, and application filing
            to ensure smooth approvals.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> High approval success rate</li>
            <li><FaCheckCircle /> Customized project solutions</li>
            <li><FaCheckCircle /> Complete documentation support</li>
            <li><FaCheckCircle /> Transparent process</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}

